/*******************************************************************************
 *** ServicePolicy ** 이용약관
 *******************************************************************************/
const ServicePolicy = () => {
    return (
        <div className="w100p h500">
            <div className="h100p mxh100p ofyA p10 bd1 bdcDDDDDD bdrd5 bgcWhite bsBdb">
                <p className="fm-c fs20 fc333333 mb10 lh20 pl5 taC">
                    전국우정노동조합 이용약관
                </p>

                <div className="fm-c fs16 fwB fc1A5276 mt30 mb5 p5-10 bgcECF0F1 bdrd3">제1조(목적)</div>
                <p className="fm-c fs15 fc333333 mb8 lh20 pl5">
                    본 약관은 전국우정노동조합(이하 “조합”)이 운영하는 예산시스템(이하 “시스템”)의 회원가입 및
                    이용과 관련하여, 조합과 회원 간의 권리·의무 및 책임사항을 규정하는 것을 목적으로 합니다.
                </p>

                <div className="fm-c fs16 fwB fc1A5276 mt15 mb5 p5-10 bgcECF0F1 bdrd3">제2조(정의)</div>
                <p className="fm-c fs15 fc333333 mb8 lh20 pl5">
                    “시스템”이라 함은 조합의 예산 편성, 집행, 관리, 조회 등 관련 업무를 온라인으로 처리하기 위해
                    구축된 정보시스템을 의미합니다.
                    <br />
                    “회원”이라 함은 본 약관에 동의하고 시스템을 이용하기 위해 등록한 조합 간부, 지부 담당자 및
                    승인된 사용자입니다.
                    <br />
                    “관리자”란 시스템 운영 및 회원 승인, 권한 부여를 담당하는 조합 본부 담당자를 의미합니다.
                </p>

                <div className="fm-c fs16 fwB fc1A5276 mt15 mb5 p5-10 bgcECF0F1 bdrd3">제3조(약관의 효력 및 변경)</div>
                <p className="fm-c fs15 fc333333 mb8 lh20 pl5">
                    본 약관은 회원이 가입 시 동의함으로써 효력이 발생합니다.
                    <br />
                    조합은 관련 법령 또는 운영상 필요한 경우 약관을 개정할 수 있으며, 변경된 약관은 시스템 공지 또는
                    이메일 등을 통해 사전에 안내합니다.
                    <br />
                    회원이 변경된 약관에 동의하지 않을 경우 회원 탈퇴를 요청할 수 있으며, 계속 이용 시 변경 사항에
                    동의한 것으로 간주됩니다.
                </p>

                <div className="fm-c fs16 fwB fc1A5276 mt15 mb5 p5-10 bgcECF0F1 bdrd3">제4조(회원가입 및 승인)</div>
                <p className="fm-c fs15 fc333333 mb8 lh20 pl5">
                    회원가입은 실명 기반으로 이루어지며, 사용자 정보의 정확성은 회원 본인이 책임집니다.
                    <br />
                    가입 신청 후 시스템 관리자의 승인 절차를 통해 최종 회원 등록이 완료됩니다.
                    <br />
                    허위 정보 입력, 타인의 명의 도용 등의 행위는 금지되며, 적발 시 이용 제한 또는 계정 삭제가
                    가능합니다.
                </p>

                <div className="fm-c fs16 fwB fc1A5276 mt15 mb5 p5-10 bgcECF0F1 bdrd3">제5조(회원의 의무)</div>
                <p className="fm-c fs15 fc333333 mb8 lh20 pl5">
                    회원은 시스템 이용 시 관련 법령, 조합 규정, 본 약관을 준수해야 합니다.
                    <br />
                    회원은 자신의 계정 및 비밀번호 관리에 책임이 있으며, 제3자에게 공유하거나 양도할 수 없습니다.
                    <br />
                    시스템을 통해 열람·처리한 예산 정보는 외부로 유출하거나 무단으로 사용해서는 안 됩니다.
                    <br />
                    오류 또는 부정 사용이 의심되는 경우 즉시 관리자에게 알려야 합니다.
                </p>

                <div className="fm-c fs16 fwB fc1A5276 mt15 mb5 p5-10 bgcECF0F1 bdrd3">제6조(조합의 의무)</div>
                <p className="fm-c fs15 fc333333 mb8 lh20 pl5">
                    조합은 시스템을 안정적으로 운영하기 위해 최선을 다하며, 회원 정보를 보호하기 위한 보안조치를
                    시행합니다.
                    <br />
                    조합은 회원의 개인정보를 본 약관에서 정한 목적 범위 내에서만 사용하며, 관련 법령에 따라 안전하게
                    처리합니다.
                    <br />
                    조합은 시스템 개선 및 서비스 제공을 위해 필요한 경우 공지 후 서비스 내용을 변경할 수 있습니다.
                </p>

                <div className="fm-c fs16 fwB fc1A5276 mt15 mb5 p5-10 bgcECF0F1 bdrd3">제7조(개인정보의 수집 및 이용)</div>
                <p className="fm-c fs15 fc333333 mb8 lh20 pl5">
                    조합은 회원가입 및 서비스 제공을 위해 다음의 개인정보를 수집합니다.
                </p>

                <ul className="lsN pl20 mt5 mb10">
                    <li className="posR pl15 mb5 fm-c fs15 fc333333">
                        <span className="posA l0 t0 fc27AE60 fwB">•</span>
                        필수 항목: 성명, 소속 본부/지부, 직책, 연락처, 이메일, 계정 ID
                    </li>
                    <li className="posR pl15 mb5 fm-c fs15 fc333333">
                        <span className="posA l0 t0 fc27AE60 fwB">•</span>
                        선택 항목: 업무 관련 추가 정보
                    </li>
                </ul>

                <p className="fm-c fs15 fc333333 mb8 lh20 pl5">
                    수집된 정보는 회원 확인, 권한 관리, 시스템 운영 및 공지사항 전달 목적으로만 사용됩니다.
                    <br />
                    개인정보는 법령에서 정한 보유 기간 또는 회원 탈퇴 시까지 안전하게 관리됩니다.
                </p>

                <div className="fm-c fs16 fwB fc1A5276 mt15 mb5 p5-10 bgcECF0F1 bdrd3">제8조(서비스 이용 제한 및 중지)</div>
                <p className="fm-c fs15 fc333333 mb8 lh20 pl5">
                    조합은 다음과 같은 경우 회원의 시스템 이용을 제한하거나 중지할 수 있습니다.
                    <ul className="lsN pl20 mt5 mb10">
                        <li className="posR pl15 mb5 fm-c fs15 fc333333">
                            <span className="posA l0 t0 fc27AE60 fwB">•</span>
                            가입 정보 허위 제출
                        </li>
                        <li className="posR pl15 mb5 fm-c fs15 fc333333">
                            <span className="posA l0 t0 fc27AE60 fwB">•</span>
                            선택 항목: 업무 관련 추가 정보
                        </li>
                        <li className="posR pl15 mb5 fm-c fs15 fc333333">
                            <span className="posA l0 t0 fc27AE60 fwB">•</span>
                            시스템을 통한 정보 유출 또는 보안 위협
                        </li>
                        <li className="posR pl15 mb5 fm-c fs15 fc333333">
                            <span className="posA l0 t0 fc27AE60 fwB">•</span>
                            타인 계정 도용 또는 부정 사용
                        </li>
                        <li className="posR pl15 mb5 fm-c fs15 fc333333">
                            <span className="posA l0 t0 fc27AE60 fwB">•</span>
                            기타 시스템 운영을 심각하게 방해한 경우
                        </li>
                    </ul>
                    조합은 불가피한 사유로 시스템 운영을 일시 중지할 수 있으며, 사전 또는 사후에 공지합니다.
                </p>

                <div className="fm-c fs16 fwB fc1A5276 mt15 mb5 p5-10 bgcECF0F1 bdrd3">제9조(저작권 및 지적재산권)</div>
                <p className="fm-c fs15 fc333333 mb8 lh20 pl5">
                    시스템에 포함된 콘텐츠, 데이터, 화면 구성 등의 저작권은 조합에 있으며, 회원은 사전 승인 없이
                    무단 복제·배포할 수 없습니다.
                </p>

                <div className="fm-c fs16 fwB fc1A5276 mt15 mb5 p5-10 bgcECF0F1 bdrd3">제10조(책임 제한)</div>
                <p className="fm-c fs15 fc333333 mb8 lh20 pl5">
                    조합은 천재지변, 시스템 장애, 통신사고 등 불가항력적 사유로 인한 서비스 중단에 대해 책임을 지지
                    않습니다.
                    <br />
                    회원의 과실로 인한 정보 유출, 계정 도용 등에 대해서는 조합이 책임을 지지 않습니다.
                </p>

                <div className="fm-c fs16 fwB fc1A5276 mt15 mb5 p5-10 bgcECF0F1 bdrd3">제11조(회원 탈퇴)</div>
                <p className="fm-c fs15 fc333333 mb8 lh20 pl5">
                    회원은 언제든지 탈퇴를 요청할 수 있으며, 탈퇴 시 개인정보는 관련 법령을 따라 삭제 또는 분리
                    보관됩니다.
                </p>

                <div className="fm-c fs16 fwB fc1A5276 mt15 mb5 p5-10 bgcECF0F1 bdrd3">제12조(준거법)</div>
                <p className="fm-c fs15 fc333333 mb8 lh20 pl5">
                    본 약관은 대한민국 법령을 기준으로 해석하며, 분쟁 발생 시 조합 소재지를 관할하는 법원을 전속
                    관할로 합니다.
                </p>
            </div>
        </div>
    )
}

export default ServicePolicy;